import { Button } from '@mui/material';
import { useAtomValue } from 'jotai';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TaskAction } from '@kheops/graphql';
import useOpenable from '../../../hooks/useOpenable';
import { orderAtom } from '../../state/state';
import useOrderActions from '../../../hooks/useOrderActions';
import ConfirmDialog from '../../../common/components/ConfirmDialog';

export default function OrderSupplierConfirmPaymentButton(): React.JSX.Element {
  const { t } = useTranslation(['order', 'common']);
  const order = useAtomValue(orderAtom);
  const { updateOrder, isLoading } = useOrderActions({ orderReferenceId: order.reference_id, orderId: order.id });
  const { open, isOpen, close } = useOpenable();

  const handleClose = useCallback((confirmed: boolean) => {
    if (confirmed) {
      updateOrder(TaskAction.Approve);
    }

    close();
  }, [updateOrder]);

  return (
    <>
      <ConfirmDialog
        cancelLabel={t('common:cancel')}
        confirmLabel={t('order:close_order')}
        title={t('order:payment_already_done')}
        subTitle={t('order:payment_already_done_description')}
        open={isOpen}
        onClose={handleClose}
      />
      <Button
        variant="outlined"
        color="tertiary"
        onClick={open}
        loading={isLoading}
      >
        {t('order:close_order')}
      </Button>
    </>
  );
}
